





















import gql from 'graphql-tag';
import * as R from 'ramda';
import Vue from 'vue';

import { debounce } from '@/vue/utils';

interface Product {
  id: string;
  name: string;
  photo: {
    id: string;
    url: string;
  };
}

interface ProductEdge {
  node: Product;
}

interface SearchResult {
  edges: ProductEdge[];
}

const searchProductQL = gql`
  query($query: String!, $country: String!, $category: ID) {
    searchResult: searchProduct(
      query: $query
      country: $country
      category: $category
      first: 25
    ) {
      edges {
        node {
          id
          name
          photo {
            id
            url
          }
        }
      }
    }
  }
`;

export default Vue.extend({
  props: {
    category: {
      type: String as () => string,
    },
    country: {
      type: String as () => string,
      default: 'my',
    },
    defaultValue: {
      type: Object as () => Product,
    },
  },

  created() {
    // @ts-ignore
    this.timeoutId = undefined;
  },

  data() {
    const { defaultValue } = this;

    let products: Product[] = [];
    if (defaultValue) {
      products = [defaultValue];
    }

    return {
      products,
    };
  },

  computed: {
    initialValue(): string | undefined {
      return this.defaultValue ? this.defaultValue.id : undefined;
    },
  },

  methods: {
    handleSearch(val: string) {
      // @ts-ignore
      if (this.timeoutId) {
        // @ts-ignore
        clearTimeout(this.timeoutId);
      }

      const { category, country, setProducts } = this;

      // @ts-ignore
      this.timeoutId = setTimeout(async () => {
        if (val.length < 3 || !country) {
          return;
        }

        const result = await this.$apollo.query({
          query: searchProductQL,
          variables: {
            category,
            country,
            query: val,
          },
        });

        if (result.data.searchResult) {
          setProducts(
            R.map((e) => e.node, result.data.searchResult
              .edges as ProductEdge[]),
          );
        }
      }, 500);
    },

    handleSelect(val: string) {
      this.$emit('input', val);
    },

    setProducts(val: Product[]) {
      this.products = val;
    },
  },
});
